/**
 * Returns a border-colour string based on the properties of a given card.
 *
 * @param {*} data - An object with IsAutofire and Category keys, like a card
 */
export default function getBorderColour({ isAutofire = false, category } = {}) {
  if (isAutofire) {
    return 'red';
  }
  switch (category) {
    case 'Gold':
      return 'gold';
    case 'Episodic':
    case 'QuesticleStart':
    case 'QuesticleStep':
    case 'QuesticleEnd':
      return 'bronze';
    case 'Ambition':
    case 'Seasonal':
      return 'silver';
    case 'Sinister':
      return 'black';
    default:
      return 'default';
  }
}